import { render, staticRenderFns } from "./Modal-Detail-And-Edit-Teacher.vue?vue&type=template&id=893558e4&scoped=true"
import script from "./Modal-Detail-And-Edit-Teacher.vue?vue&type=script&lang=js"
export * from "./Modal-Detail-And-Edit-Teacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893558e4",
  null
  
)

export default component.exports